import { adminHttpClient } from '../../../commons/adminHttpClient'

interface DeleteProductClass {
  productClassId: string
  planPeriodId: string
}

export const deleteClassApi = (productClass: DeleteProductClass) => {
  return adminHttpClient.delete('/AdminDashboard/ClassDesign/DeleteClass', {
    data: productClass,
  })
}
